import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import Truncate from "react-truncate";

import { Avatar } from "reakit";
import { Box, Button, Flex, Text } from "rebass";
import { LeaveStatus as LeaveActor } from "../Base/styles";
import { withFirebase } from "../Firebase";
import { schoolActions, schoolSelectors } from "../../store/school";
import { authActions, authSelectors } from "../../store/auth";
import LeaveDetailsPopup from "../AirportTab/LeaveDetailsPopup";
import { Span } from "../Base";

import { ButtonText, FullWidthButton, LabelContainer } from "./styles";
import { leaveUtils } from "../../utils";

const fontSizes = ["11px", "11px", "11px", "0.8em"];

class LeavesBar extends Component {
  state = {
    student: { first_name: "Loading...", last_name: "", parents: [] },
    loading: false,
    hosts: [],
    expandNotes: false,
    handleButtonPress: "",
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchStudentDetails();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.details && prevProps.details !== this.props.details) {
      this.updateHosts();
    }
  }

  updateHosts = async () => {
    const { details } = this.props;
    let parents = [];
    if (details && details.host) {
      for (let i in details.host) {
        let parentRef = await this.props.firebase.parent(details.host[i]).get();
        let parentRefData = parentRef.data();
        parents.push({
          id: parentRef.id,
          first_name: parentRefData.first_name,
          last_name: parentRefData.last_name,
        });
      }
    }
    this.setState({ hosts: parents });
  };

  fetchStudentDetails = async () => {
    const { details, profile, isFaculty } = this.props;
    if (isFaculty) {
      if (details.student_details) {
        this.setState({ student: details.student_details, loading: false });
      }
    } else {
      this.setState({ student: profile, details, loading: false });
    }
    this.updateHosts();
  };

  handleApprove = async () => {
    const { firebase, details, isFaculty } = this.props;
    if (isFaculty) {
      if (details.status === 0) {
        try {
          let leavesRef = firebase.leave(details.id);
          leavesRef.update({
            status: 4,
          });
          this.setState({ handleButtonPress: "APPROVED" });
          // history.push('/app/leaves')
        } catch (error) {}
      } else if (details.status === 5) {
        try {
          let leavesRef = firebase.leave(details.id);
          leavesRef.update({
            status: 7,
          });
          this.setState({ handleButtonPress: "APPROVED" });
          // history.push('/app/leaves')
        } catch (error) {}
      } else if (!details.parent_host) {
        if (details.status === 6) {
          try {
            let leavesRef = firebase.leave(details.id);
            leavesRef.update({
              status: 8,
            });
            this.setState({ handleButtonPress: "APPROVED" });
            // history.push('/app/leaves')
          } catch (error) {}
        } else if (details.status === 9) {
          try {
            let leavesRef = firebase.leave(details.id);
            leavesRef.update({
              status: 10,
            });
            this.setState({ handleButtonPress: "APPROVED" });
            // history.push('/app/leaves')
          } catch (error) {}
        }
      }
    }
  };

  handleDecline = async () => {
    const { firebase, details, isFaculty } = this.props;
    if (isFaculty) {
      try {
        let leavesRef = firebase.leave(details.id);
        leavesRef.update({
          status: 1,
        });
        this.setState({ handleButtonPress: "DECLINED" });
        // history.push('/app/leaves')
      } catch (error) {}
    }
  };

  handleSignout = async () => {
    const { firebase, details, isFaculty, profile } = this.props;
    if (isFaculty) {
      try {
        let studentRef = firebase.student(details.student_uid);
        studentRef.update({
          on_leave: true,
          leave_type: details.leave_type,
        });

        let waveRef = studentRef.collection("wave_history");
        let newWave = waveRef.doc();
        newWave.set({
          creator_uid: profile.id,
          location_is_geowave: false,
          on_leave: true,
          leave_type: details.leave_type,
          post_time: Math.floor(Date.now() / 1000),
        });

        let leavesRef = firebase.leave(details.id);
        leavesRef.update({
          status: 11,
        });
        this.setState({ handleButtonPress: "SIGNED OUT" });
        // history.push('/app/leaves')
      } catch (error) {
        console.log(error);
      }
    }
  };

  handleSignin = async () => {
    const { firebase, details, isFaculty, profile } = this.props;
    if (isFaculty) {
      try {
        let newLocUid = "WmvfYHXXazFfBYnyej2Y";
        let studentRef = firebase.student(details.student_uid);
        studentRef.update({
          on_leave: false,
          leave_type: null,
          current_location: newLocUid,
        });

        let waveRef = studentRef.collection("wave_history");
        let newWave = waveRef.doc();
        newWave.set({
          creator_uid: profile.id,
          location_is_geowave: false,
          location_uid: newLocUid,
          post_time: Math.floor(Date.now() / 1000),
        });

        let leavesRef = firebase.leave(details.id);
        leavesRef.update({
          status: 12,
        });
        this.setState({ handleButtonPress: "SIGNED IN" });
        // history.push('/app/leaves')
      } catch (error) {}
    }
  };

  handleResend = async () => {
    const { firebase, details, isFaculty } = this.props;
    if (isFaculty) {
      try {
        let leavesRef = firebase.leave(details.id);
        let tempStatus = details.status;
        leavesRef.update({
          status: null,
        });
        leavesRef.update({
          status: tempStatus,
        });
        // history.push('/app/leaves')
      } catch (error) {}
    }
  };

  handleUndoSignout = async () => {
    const { firebase, details, isFaculty } = this.props;
    if (isFaculty) {
      try {
        let leavesRef = firebase.leave(details.id);
        if (details.parent_host) {
          leavesRef.update({
            status: 7,
          });
        } else {
          leavesRef.update({
            status: 10,
          });
        }
        let studentRef = firebase.student(details.student_uid);
        studentRef.update({
          on_leave: false,
          leave_type: null,
        });
        // history.push('/app/leaves')
      } catch (error) {}
    }
  };

  render() {
    const {
      details,
      types,
      schoolInfo,
      firebase,
      isAdmin,
      profile,
      leave_type,
    } = this.props;
    const { student, hosts, expandNotes, handleButtonPress } = this.state;
    const type = types[details.leave_type];
    const startDate = moment
      .unix(details.start_date)
      .format("MMM DD, YYYY     hh:mm A");
    const endDate = moment
      .unix(details.end_date)
      .format("MMM DD, YYYY     hh:mm A");
    let actorStatus = leaveUtils.returnLeaveActorColors(details.status);
    if (details.host && !details.parent_host) {
      actorStatus = leaveUtils.returnLeaveActorColors(details.status, false);
    }
    return (
      <tr width={1}>
        <th style={{ backgroundColor: "white" }}>
          {/* Status and Student Avatar */}
          <Flex flexDirection={"row"} pt={2}>
            <Box p={2}>
              <Avatar
                src={student.profile_pic}
                height={"25px"}
                width={"25px"}
                backgroundColor={"#121212"}
              />
            </Box>
            <Flex
              flexDirection={"column"}
              flexWrap={"wrap"}
              justifyContent={"center"}
            >
              <Text
                pb={"5px"}
                color={"black"}
                fontSize={fontSizes}
                fontWeight={"lighter"}
              >
                {student.first_name} {student.last_name}
              </Text>
            </Flex>
          </Flex>
        </th>

        <td>
          <Flex flexDirection={"row"}>
            <LeaveActor bg={actorStatus.host} mt={"3px"}>
              {/* <Text mt={'3px'} color={actorStatus.hostText}>H</Text> */}
              <Text mt={"3px"} color={"white"}>
                H
              </Text>
            </LeaveActor>
            <LeaveActor bg={actorStatus.dean}>
              {/* <Text color={actorStatus.deanText} mt={'3px'}>D</Text> */}
              <Text color={"white"} mt={"3px"}>
                D
              </Text>
            </LeaveActor>
            <LeaveActor bg={actorStatus.parent}>
              {/* <Text mt={'3px'} color={actorStatus.parentText}>P</Text> */}
              <Text mt={"3px"} color={"white"}>
                P
              </Text>
            </LeaveActor>
          </Flex>
        </td>

        {/*Leave Type */}
        <td>
          <Text
            color={"black"}
            fontSize={fontSizes}
            textAlign={"left"}
            fontWeight={"lighter"}
          >
            {type.name}
          </Text>
        </td>

        {/*	 Leave At and Return At */}
        <td>
          <Text
            fontSize={fontSizes}
            py={2}
            textAlign={"left"}
            fontWeight={"lighter"}
          >
            {startDate}
          </Text>
        </td>
        <td>
          <Text
            fontSize={fontSizes}
            py={2}
            textAlign={"left"}
            fontWeight={"lighter"}
          >
            {endDate}
          </Text>
        </td>

        {/* Leave by and Return by*/}
        <td>
          <Text
            py={2}
            textAlign={"left"}
            fontSize={fontSizes}
            fontWeight={"lighter"}
          >
            {schoolInfo.transportTypes
              .filter((type) => type.id === details.leave_transportation)
              .map((type) => type.name)}
          </Text>
        </td>
        <td>
          <Text
            fontSize={fontSizes}
            textAlign={"left"}
            py={2}
            fontWeight={"lighter"}
          >
            {schoolInfo.transportTypes
              .filter((type) => type.id === details.return_transportation)
              .map((type) => type.name)}
          </Text>
        </td>

        {/* Host */}
        <td>
          {hosts.length > 0 ? (
            <React.Fragment>
              {hosts.map((host) => (
                <React.Fragment>
                  {student.parents && student.parents.includes(host.id) ? (
                    <Text
                      fontSize={fontSizes}
                      textAlign={"left"}
                      py={2}
                      fontWeight={"lighter"}
                    >
                      {host.first_name} {host.last_name}
                      <div>
                        <Span color={"meta"}>(Parent)</Span>
                      </div>
                    </Text>
                  ) : (
                    <Text
                      fontSize={fontSizes}
                      textAlign={"left"}
                      py={2}
                      fontWeight={"lighter"}
                    >
                      {host.first_name} {host.last_name}
                    </Text>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ) : (
            <Text
              fontSize={fontSizes}
              py={2}
              textAlign={"left"}
              fontWeight={"lighter"}
            >
              No Host Necessary
            </Text>
          )}
        </td>

        {/* Destination */}
        <td>
          <Text
            fontSize={fontSizes}
            textAlign={"left"}
            py={2}
            fontWeight={"lighter"}
          >
            {details.destination}
          </Text>
        </td>

        {/* Notes */}
        <td style={{ maxWidth: ["120px"] }}>
          <Text
            fontSize={fontSizes}
            py={2}
            textAlign={"left"}
            fontWeight={"lighter"}
          >
            <Truncate
              lines={expandNotes ? false : 2}
              ellipsis={
                <Text
                  fontSize={"8px"}
                  color={"blue"}
                  onClick={() =>
                    this.setState({ expandNotes: !this.state.expandNotes })
                  }
                >
                  ... Read more
                </Text>
              }
            >
              {details.notes}
            </Truncate>
          </Text>
          {expandNotes && (
            <Text
              textAlign={"left"}
              fontSize={"8px"}
              color="blue"
              onClick={() => this.setState({ expandNotes: false })}
            >
              Less
            </Text>
          )}
        </td>
        {/*<Box width={2/13}>*/}

        {/* Button Section */}
        <td style={{ maxHeight: "30px", textAlign: "left" }}>
          {/* Approve / Decline buttons*/}
          {isAdmin && details && (
            <React.Fragment>
              {details.parent_host ? (
                <React.Fragment>
                  {(details.status === 0 || details.status === 5) &&
                    (handleButtonPress !== "" ? (
                      handleButtonPress === "APPROVED" ? (
                        <Flex justifyContent={"center"}>
                          <LabelContainer>Approved by Deans</LabelContainer>
                        </Flex>
                      ) : (
                        <Flex justifyContent={"center"}>
                          <LabelContainer>Declined by Deans</LabelContainer>
                        </Flex>
                      )
                    ) : (
                      <Flex justifyContent={"center"}>
                        <FullWidthButton
                          mx={1}
                          variant={"second"}
                          bg={"green"}
                          onClick={this.handleApprove}
                        >
                          <ButtonText>Approve</ButtonText>
                        </FullWidthButton>
                        <FullWidthButton
                          mx={1}
                          variant={"second"}
                          bg={"red"}
                          onClick={this.handleDecline}
                        >
                          <ButtonText>Decline</ButtonText>
                        </FullWidthButton>
                      </Flex>
                    ))}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {(details.status === 0 ||
                    details.status === 5 ||
                    details.status === 6 ||
                    details.status === 9) &&
                    (handleButtonPress !== "" ? (
                      handleButtonPress === "APPROVED" ? (
                        <Flex justifyContent={"center"}>
                          <LabelContainer>Approved by Deans</LabelContainer>
                        </Flex>
                      ) : (
                        <Flex justifyContent={"center"}>
                          <LabelContainer>Declined by Deans</LabelContainer>
                        </Flex>
                      )
                    ) : (
                      <Flex justifyContent={"center"}>
                        <FullWidthButton
                          mx={1}
                          variant={"second"}
                          bg={"green"}
                          onClick={this.handleApprove}
                        >
                          <ButtonText>Approve</ButtonText>
                        </FullWidthButton>
                        <FullWidthButton
                          mx={1}
                          variant={"second"}
                          bg={"red"}
                          onClick={this.handleDecline}
                        >
                          <ButtonText>Decline</ButtonText>
                        </FullWidthButton>
                      </Flex>
                    ))}
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          {/* Signin Buttons*/}
          {details && details.status === 11 && (
            <Fragment>
              <Box width={1}>
                <Button
                  mx={1}
                  bg={handleButtonPress === "SIGNED IN" ? "meta" : "green"}
                  disabled={handleButtonPress === "SIGNED IN"}
                  variant={"second"}
                  onClick={this.handleSignin}
                >
                  <ButtonText>
                    {handleButtonPress === "SIGNED IN"
                      ? "Signed In"
                      : "Sign In"}
                  </ButtonText>
                </Button>
              </Box>
            </Fragment>
          )}

          {/* Signout Buttons*/}
          {student &&
            student.parents &&
            details &&
            details.status > 3 &&
            details.status < 11 && (
              <Fragment>
                <Flex
                  flexWrap={"wrap"}
                  justifyContent={"flex-end"}
                  flexDirection={"row"}
                  width={1}
                >
                  {details.parent_host && details.status === 7 && (
                    <Button
                      mx={1}
                      bg={
                        student.on_leave || handleButtonPress === "SIGNED OUT"
                          ? "meta"
                          : "green"
                      }
                      variant={"second"}
                      disabled={
                        student.on_leave || handleButtonPress === "SIGNED OUT"
                      }
                      onClick={this.handleSignout}
                    >
                      <ButtonText>
                        {student.on_leave
                          ? "On Leave"
                          : handleButtonPress === "SIGNED OUT"
                          ? "Signed Out"
                          : "Sign Out"}
                      </ButtonText>
                    </Button>
                  )}
                  {!details.parent_host && details.status === 10 && (
                    <Button
                      mx={1}
                      bg={
                        student.on_leave || handleButtonPress === "SIGNED OUT"
                          ? "meta"
                          : "green"
                      }
                      variant={"second"}
                      disabled={
                        student.on_leave || handleButtonPress === "SIGNED OUT"
                      }
                      onClick={this.handleSignout}
                    >
                      <ButtonText>
                        {student.on_leave
                          ? "On Leave"
                          : handleButtonPress === "SIGNED OUT"
                          ? "Signed Out"
                          : "Sign Out"}
                      </ButtonText>
                    </Button>
                  )}

                  <Box pr={2} />
                </Flex>
              </Fragment>
            )}

          {/* Approved Label*/}
          {details &&
            (details.status === 4 ||
              (!details.parent_host && details.status === 7) ||
              details.status === 8) && (
              <Flex justifyContent={"center"}>
                <LabelContainer>Approved by Deans</LabelContainer>
              </Flex>
            )}
        </td>

        <td style={{ maxHeight: "30px", textAlign: "left" }}>
          {details && (
            <LeaveDetailsPopup
              profile={profile}
              isAdmin={isAdmin}
              firebase={firebase}
              student={student}
              details={details}
              school={schoolInfo}
              hosts={hosts}
              leave_type={leave_type}
              handleDecline={this.handleDecline}
              handleApprove={this.handleApprove}
              handleSignout={this.handleSignout}
              handleSignin={this.handleSignin}
              handleResend={this.handleResend}
              handleUndoSignout={this.handleUndoSignout}
            />
          )}
        </td>
      </tr>
    );
  }
}

LeavesBar.propTypes = {
  details: PropTypes.object,
  missed: PropTypes.bool,
};

LeavesBar.defaultProps = {
  details: null,
  missed: false,
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  profileInfo: authSelectors.refreshProfile(state.auth),
  loading: authSelectors.isLoading(state.auth),
  isFaculty: authSelectors.isFaculty(state.auth),
});

const mapDispatchToProps = (dispatch) => ({
  updateSchoolInfo: (data) => {
    dispatch(schoolActions.updateSchoolInfo(data));
  },
  updateProfileInfo: (data) => {
    dispatch(authActions.updateProfileInfo(data));
  },
});
export default withFirebase(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeavesBar)
);
